var storefrontApp = angular.module("storefrontApp");
//#region Home Service
storefrontApp.service('detailsService', ['$http', function ($http) {
    return {
        getProjectInspirations: function (projectId) {
            return $http.get('storefrontapi/learningcenter/getprojectinspirations?projectId=' + projectId);
        },
        getEmbroideryProjects: function (count) {
            return $http.get('storefrontapi/learningcenter/embroideryprojects?count=' + count);
        },
        getLookbook: function (count) {
            return $http.get('storefrontapi/learningcenter/toplookbooks?count='+count);
        },
        getProjectById: function(projectId){
            return $http.get('storefrontapi/learningcenter/projectbyid?projId='+projectId);
        },
        getProjectsByAuthorId: function(authorId){
            return $http.get('storefrontapi/learningcenter/projectsbyauthorid?authorId=' + authorId);
        },
        getPreviousNextEmbroideryProjects: function(projectId){
            return $http.get('storefrontapi/learningcenter/getpreviousnextprojects?projId=' + projectId);
        },
        getProjectPDFUrl: function(projectId){
            return $http.get('storefrontapi/learningcenter/projectpdfurlbyid?projId=' + projectId);
        },
        submitprojectfeedback: function(formData){          
            return $http.post('storefrontapi/learningcenter/submitprojectfeedback', 
                formData
            );
        },
        getProjectReviewsById: function(projectId){
            return $http.get('storefrontapi/learningcenter/projectreviewsbyid?projId='+projectId);
        },
        getTopProducts: function (topProductsRequest) {
            return $http.post("storefrontapi/product/gettopproducts", topProductsRequest);
        },
        sendEmailOnReferProduct: function (formData) {
            return $http.post(
                "storefrontapi/product/refer",
                formData,
                {
                    headers: { "Content-Type": undefined },
                }
            );

        },
    }
}]);
